module.exports = __webpack_public_path__ + "img/dashboard.29ede75b.png";